/**
 * @fileoverview POST handler for the "/:app_group_id/campaign/:campaign_id/copy/:target_app_group_id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { postCampaignCacheKeys } from "./constants";
import type { PostCampaignCopyProps, PostCampaignCopyResponse } from "./types";

export const postCampaignCopy = reactQueryMutationAdapter(
  postCampaignCacheKeys,
  (props: PostCampaignCopyProps): Promise<PostCampaignCopyResponse> => {
    return fetch<PostCampaignCopyResponse>(
      `/${props.appGroupId}/campaign/${props.campaignId}/copy/${props.targetAppGroupId}`,
      "POST",
      {},
      undefined,
      {
        propagateFetchRequestError: false,
      }
    );
  }
);
